//@vendor
require('./myProfileKeysSignatureEndFailure.scss');
const React = require('react');
const PropTypes = require('prop-types');
//@commons
const { FormattedText, formatText } = require('core/i18n').i18n;
const WizardError = require('components/commons/wizardError/wizardError');
//@constants
const { FAILURE_SCREEN_PROPS } = require('../constants/myProfileKeysSignatureProps');


const myProfileKeysSignatureEndFailure = ({immVariables, lowBiocatchAvailable, onRetryButtonClick}) => {
    const goBackButton = {
        label: formatText('signatureEdit-signatureEdit_errorRetryButton'),
    }
    const cancelButton = FAILURE_SCREEN_PROPS[lowBiocatchAvailable].cancelButton ? {
        url : FAILURE_SCREEN_PROPS[lowBiocatchAvailable].cancelButton.url,
        label: formatText(FAILURE_SCREEN_PROPS[lowBiocatchAvailable].cancelButton.label)
    } : {};
    return (
        <WizardError
            errorMessage={formatText('signatureEdit-signatureEdit_errorTitle')}
            mainButton={goBackButton}
            onMainButtonClick={onRetryButtonClick}
            mainButtonCustomModifier="primary"
            cancleButton={cancelButton}
            footerCustomClassName="my-profile-keys-signature-failure__footer-buttons"
        >
            <FormattedText
                injectedStrings={[immVariables.getIn(['telefono', 'cliente'])]}
                value="signatureEdit-signatureEdit_errorSubtitle"
            />
        </WizardError>
    );
};

myProfileKeysSignatureEndFailure.propTypes = {
    lowBiocatchAvailable: PropTypes.string.isRequired,
    immVariables: PropTypes.object.isRequired,
    onRetryButtonClick: PropTypes.func.isRequired,
}

module.exports = myProfileKeysSignatureEndFailure;